import { put2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { MapSettingsResponse } from "@/shared/v2/queries/interfacesV2";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const useMapOverviewSettingsMutation = () => {
  const branch = useBranchId();

  const { t } = useTranslation();
  const mutation = useMutation({
    onSuccess: () => {
      toast.success(t("success.success"));
    },
    onError: () => {
      toast.error(t("errors.500"));
    },
    mutationFn: (body: MapSettingsResponse) =>
      put2(`/internal/secure/pos/v2/map/overview/screen/settings/${branch}`, {
        ...body,
        item_id: undefined,
      }),
  });
  return mutation;
};

export default useMapOverviewSettingsMutation;
